import { render, staticRenderFns } from "./ProductSlider.vue?vue&type=template&id=04dd8789&scoped=true"
import script from "./ProductSlider.vue?vue&type=script&lang=js"
export * from "./ProductSlider.vue?vue&type=script&lang=js"
import style0 from "./ProductSlider.vue?vue&type=style&index=0&id=04dd8789&prod&scoped=true&lang=css"
import style1 from "./ProductSlider.vue?vue&type=style&index=1&id=04dd8789&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dd8789",
  null
  
)

export default component.exports